import gbSeamlessScroll from "./src/gb-seamless-scroll.vue";
const gbSeamlessScrollCompenet = function(Vue) {
  Vue.component(gbSeamlessScroll.name, gbSeamlessScroll);
};
export default gbSeamlessScrollCompenet;
